export function handleClientFooter() {
    // Add background color to client footer - option 3
    const footerOption3 = document.querySelector('.footer-option-3') as HTMLElement;
    if (!footerOption3) {
        return;
    }
    const footer = document.querySelector('.site-footer') as HTMLElement;
    const primaryFooter = document.querySelector('.site-primary-footer-wrap') as HTMLElement;
    const belowFooter = document.querySelector('.site-below-footer-wrap') as HTMLElement;
    let primaryFooterColour = window.getComputedStyle(primaryFooter).backgroundColor;
    let belowFooterColour = window.getComputedStyle(belowFooter).backgroundColor;
    footer.style.background = `linear-gradient(90deg, ${belowFooterColour} 50%, ${primaryFooterColour} 50%)`;
    footer.style.opacity = '1';
}